import { render, staticRenderFns } from "./verifyCompany.vue?vue&type=template&id=0bd36f0a"
import script from "./verifyCompany.vue?vue&type=script&lang=js"
export * from "./verifyCompany.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports